export default {
  home: "首页",
  product: "产品中心",
  apply: "行业应用",
  zlykkx: '质量与可靠性',
  support: "设计&技术支持",
  onlineClass: "在线课堂",
  tecArticles: "技术文章",
  aboutUs: "关于士模",
  introduce: '公司介绍',
  news: "新闻资讯",
  contact: '联系我们',
  xsydls: "销售与代理商",
  joinUs: "加入我们",
  LearnMore: "了解更多",
  ProductCenter: "产 品 中 心",
  IndustryApplication: "行 业 应 用",
  CompanyProfile: "公司介绍",
  InvestmentPartners: "投资伙伴",
  ContactUs: "联系我们",
  NewsCenter: "新 闻 资 讯",
  footer1: "聚焦高性能模拟信号链芯片设计",
  BeijingOffice: "北京公司",
  BeijingAddress: "北京市海淀区学清路10号院学清嘉创大厦A座9层",
  ChengduOffice: "成都公司",
  ChengduAddress: "成都市高新区吉泰路10号汇顶科技大厦1栋1单元10层",
  SalesInquiries: "销售和技术支持",
  sales1: "（华北/西北/西南）",
  sales2: "（华东/华中）",
  sales3: "（华南）",
  sales4: "(全国)",
  Email: "邮箱",
  Sales: "销售",
  Recruitment: "招聘",
  service: "服务",
  FollowUs: "关注我们",
  NewProducts: "最新发布",
  ProductSelectionTable: "产品选型表",
  Filters: "筛选器",
  SearchPart: "查找产品型号",
  Reset: "重置",
  ProductInformation: "产品信息",
  Description: "概述",
  ProductVideo: "产品视频",
  Features: "特性",
  Applications: "应用",
  OrderingGuide: "订购信息",
  SalesInquiry: "销售和技术支持",
  address: "地区",
  address1: "地区",
  phone: "电话",
  wechat: "微信",
  NewProductReleases: "最新发布",
  productDetail: "产品详情",
  globalSeo: {
    title: '士模微电子 | 国产供应链，高性能数据转换器芯片',
    description: '士模微电子专注于国产高性能数据转换器芯片，提供可靠的模拟芯片解决方案。',
    keywords: '数据转换器,ADC,DAC,模拟芯片,国产芯片'
  },
  SocialRecruitment:"社会招聘",
  CampusRecruitment:"校园招聘",
  ViewJobs:"查看职位",
  RecruitmentContents:"在士模，我们有业内知名专家带领团队，工作中强调专注高效、结果导向，打造让每个人都能茁壮成长的平台。我们将优秀的伙伴视为最大的财富，欢迎追求创新和接受挑战的伙伴加入士模微电子，实现与公司共同成长、相互成就。",
  aboutustest11:"大咖带领的",
  aboutustest12:"高效团队",
  aboutustest13:"行业知名专家带领团队；",
  aboutustest14:"扁平化管理",
  aboutustest21:"行业领先的",
  aboutustest22:"研发成果",
  aboutustest23:"知识产权自主可控",
  aboutustest24:"原创性技术成果国际排名前列",
  aboutustest31:"创新驱动的",
  aboutustest32:"学习平台",
  aboutustest33:"前沿技术交流",
  aboutustest34:"特色化培训平台",
  aboutustest41:"丰富多彩的",
  aboutustest42:"团建活动",
  aboutustest43:"年会、春游、飞盘、冰壶等时下最新潮的活动，让我们了解工作以外你们的才能，你想到的我们有，你没想到的我们也有……",
  aboutustest51:"务实平等的",
  aboutustest52:"工作环境",
  aboutustest53:"开放式办公环境，团队合作更加高效",
  aboutustest54:"弹性工作，时间自主掌控",
  introduce1:'人才招聘',
  introduce2:'业务合作',
  introduce3:'公司地址',
  introduce4:'北京士模',
  introduce5:'成都士模',
  dlrzx:"代理人咨询",
  xsytet1:"代理商",
  xsytet2:"联系人",
  xsytet3:"网址",
  xsytet4:"在线购买",
  xsytet5:"网上商城",
  datasheet:"数据手册",
  prevText:"上一页",
  nextText:"下一页",

}


// WEBPACK FOOTER //
// ./src/lang/zh.js